import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import Divider from '../General/Divider';
import Text from '../../Global/Text';
// Constants
import { stepComponents } from '../../../constants/Steps';
// Utils
import {
  calcColumns
} from '../../../utilities/form/formUtils';

export const Confirmation = ({
    componentProps,
    className,
    logo,
    logoTitle,
    showLogo
}) => {
  return (
    <div className={`step step--basic step--confirmation ${className}`}>
          {/* If there's any props */}
          {showLogo && 
            <>
              <Divider className='basic_component_divider'/>
              <div className='basic_component_wrapper'>
                <Text className='basic_component_wrapper_logo' value={logo} /> 
                <Text className='basic_component_wrapper_desc' value={logoTitle}/>
              </div>
            </>
          }
          {
            componentProps.length > 0 && (
              <div className="step__content">
                {
                  componentProps.map(componentProp => {
                    const InputComponent = stepComponents[componentProp.type];
                    if (InputComponent) {
                      const inputParams = {
                        'columns': calcColumns(componentProp),
                        'children': componentProps,
                        ...componentProp
                      }
                      return (
                        <CSSTransition
                          in={true}
                          timeout={300}
                          classNames="slideInTop"
                          unmountOnExit
                        >
                          <InputComponent {...inputParams} />
                        </CSSTransition>
                      );
                    }
                  })
                }
              </div>
            )
          }
          {showLogo && <Divider className='basic_component_divider'/>}
    </div>
  )
}

Confirmation.defaultProps = {
  logo: "${tryg-logo-size-fina}",
  logoTitle: "${tryg-logo-title-fina}",
  showLogo: false
}

Confirmation.propTypes = {
  componentProps: PropTypes.array.isRequired,
  className: PropTypes.string,
  logo: PropTypes.string,
  logoTitle: PropTypes.string,
  showLogo: PropTypes.bool
};